import React from 'react';
import { ButtonLink, Checkbox, checkboxStates, Icon } from 'bench-internal-theme';
import { colors } from 'bench-style-constants';
import { IconColumn } from './DataEntryTableColumnDefinitions.styles';
import { HideOnColumnHover, ShowOnColumnHover } from './QualityIssuesSelectColumn.styles';
import { DataEntry } from '../types';
import { useSelectedEntries } from '../hooks/useSelectedEntries';

export type QualityIssuesSelectColumnProps = {
  hasPotentialQualityIssues: boolean;
  id: string;
  dataEntry: DataEntry;
  ledgerAccountId: string;
};

const QualityIssuesSelectColumn = ({
  hasPotentialQualityIssues,
  id,
  dataEntry,
  ledgerAccountId,
}: QualityIssuesSelectColumnProps) => {
  const {
    hasSelectedDataEntryId,
    addSelectedDataEntries,
    removeSelectedDataEntryIds,
    hasSelectedLedgerAccountId,
    hasDeselectedDataEntryId,
    addDeselectedDataEntryIds,
    removeDeselectedDataEntryIds,
  } = useSelectedEntries();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    // Prevent the sidebar from toggling
    event.stopPropagation();

    if (
      hasSelectedLedgerAccountId(ledgerAccountId) &&
      !hasDeselectedDataEntryId(ledgerAccountId, id)
    ) {
      return addDeselectedDataEntryIds(ledgerAccountId, [id]);
    } else if (
      hasSelectedLedgerAccountId(ledgerAccountId) &&
      hasDeselectedDataEntryId(ledgerAccountId, id)
    ) {
      return removeDeselectedDataEntryIds(ledgerAccountId, [id]);
    }

    if (hasSelectedDataEntryId(id)) {
      removeSelectedDataEntryIds([id]);
    } else {
      addSelectedDataEntries([dataEntry]);
    }
  };

  return (
    <IconColumn
      styleType={hasPotentialQualityIssues ? 'warning' : undefined}
      title={hasPotentialQualityIssues ? 'Potential quality issue' : undefined}
      // This handles the case where you juuuust slightly miss clicking on the checkbox and avoids opening the journal entry sidebar.
      onMouseUp={handleClick}
    >
      <ButtonLink onMouseUp={handleClick}>
        {/* Unselected data entries with potential quality issues have a warning icon in
                this column and it turns into a checkbox when the column is hovered */}
        {!hasSelectedDataEntryId(id) &&
        !hasSelectedLedgerAccountId(ledgerAccountId) &&
        hasPotentialQualityIssues ? (
          <>
            <HideOnColumnHover>
              <Icon color={colors.copper} icon="triangleExclamationMark" size="small" />
            </HideOnColumnHover>
            <ShowOnColumnHover>
              <Checkbox checkboxState={checkboxStates.UNCHECKED} />
            </ShowOnColumnHover>
          </>
        ) : (
          <Checkbox
            checkboxState={
              hasSelectedDataEntryId(id) ||
              (hasSelectedLedgerAccountId(ledgerAccountId) &&
                !hasDeselectedDataEntryId(ledgerAccountId, id))
                ? checkboxStates.CHECKED
                : checkboxStates.UNCHECKED
            }
          />
        )}
      </ButtonLink>
    </IconColumn>
  );
};

export default QualityIssuesSelectColumn;
